import { SET_PROJECT_FIELD } from './actions';

const initialState = {
    projects: [],
    userProjects: [],
    clicked: false,
    isLoaded: false,
    userProjectIsLoaded: false,
    selected: [],
};

export function projectReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PROJECT_FIELD:
            return { ...state, [action.key]: action.value };
        default:
            return state;
    }
}
